import { CaseStudy, SimulationEhr } from 'models/ui';
import { Box } from 'components/common';
import { ELSFlex, ELSFlexItem } from 'components/common/els';
import AssignmentInfoView from 'components/common/quick-view/AssignmentInfoView';
import { AssignmentType } from 'models/enum';

export interface ContentInformationViewProps {
  activeTab: number;
  selectedContent: CaseStudy | SimulationEhr;
  onTabGroupClick: Function;
  isBookOrganized: boolean;
  assignmentType?: AssignmentType;
}

const ContentInformationView = (props: ContentInformationViewProps) => {
  const { id, patient } = props.selectedContent || {};
  if (!id) {
    return null;
  }
  return (
    <>
      <Box mt2 className="quick-view__patient-info">
        <ELSFlex spaceBetween>
          <ELSFlexItem>
            <p>Patient name (Last, First)</p>
            <h4>{`${patient?.lastName} ${patient?.firstName}`}</h4>
          </ELSFlexItem>
          <ELSFlexItem className="u-els-float-left u-els-text-right">
            <p>Hospital Floor</p>
            <h4>{patient?.hospitalFloor}</h4>
          </ELSFlexItem>
        </ELSFlex>
      </Box>
      <AssignmentInfoView activeTab={props.activeTab} selectedContent={props.selectedContent} onTabGroupClick={props.onTabGroupClick} isBookOrganized={props.isBookOrganized} assignmentType={props.assignmentType} />
    </>
  );
};

ContentInformationView.displayName = 'ContentInformationView';
export default ContentInformationView;
